import { useTranslation } from "react-i18next";
import { IOrderActivityLog } from "../../../interfaces";
import {
  formatDateAndTime,
  getFileNameWithoutFolderName,
  getFileSizeInMb,
} from "../../../utils";

/**
 * This component is used to show delete position image card
 * @param param0 activity log details
 */
const DeletedLogComponent = ({
  activityLog,
}: {
  activityLog: IOrderActivityLog;
}) => {
  const { t } = useTranslation();
  if (!activityLog.positionImage) return <></>;
  return (
    <div>
      <div className="card-auto p-24 my-10">
        <div>
          {formatDateAndTime(activityLog.createdAt, "DD.MM.YYYY HH:mm:ss")}
        </div>
        <div>
          {activityLog.updatedBy} <strong>{t("deleted")}</strong>{" "}
          {t("printdata")}
        </div>
        {activityLog.positionImage && (
          <div className="overflow-wrap-break-word">
            {getFileNameWithoutFolderName(activityLog.positionImage.key)} (
            {activityLog.positionImage.size &&
              getFileSizeInMb(activityLog.positionImage.size)}
            MB)
          </div>
        )}
      </div>
    </div>
  );
};

export default DeletedLogComponent;
